import React from 'react';
import { Checkbox } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNotify } from '../../hooks/notificationHook';
import { useLabelForEstimatedDeliveryPeriod } from '../../hooks/useLabel';
import SoldOutTag from './SoldOutTag';
var SampleOrderCheckbox = function (_a) {
    var _b, _c, _d;
    var role = _a.role, orderedItem = _a.orderedItem, isSecondaryDirectSampleOrder = _a.isSecondaryDirectSampleOrder, checked = _a.checked, disabled = _a.disabled, onChange = _a.onChange;
    var t = useTranslation().t;
    var notify = useNotify();
    var labelForEstimatedDeliveryPeriod = useLabelForEstimatedDeliveryPeriod();
    var deliverySampleWarningMessage = React.useMemo(function () {
        var _a;
        if (orderedItem.type === 'Offer' ||
            ((_a = orderedItem.offer.offerList.roasterTransportToWarehouse) === null || _a === void 0 ? void 0 : _a.status) ===
                'warehousing') {
            return '';
        }
        var approvalDate = labelForEstimatedDeliveryPeriod(orderedItem.offer.offerList.roasterTransportToWarehouse);
        return t('messages.deliverySampleWarningMessage', { approvalDate: approvalDate });
    }, [t, orderedItem, labelForEstimatedDeliveryPeriod]);
    var handleClick = React.useCallback(function (event) {
        event.stopPropagation();
        if (disabled)
            notify('info', [t('messages.invalidOrderCombination')]);
    }, [t, disabled, notify]);
    var handleChange = React.useCallback(function (event, checked) {
        onChange(checked);
        if (checked && deliverySampleWarningMessage)
            notify('warning', [deliverySampleWarningMessage]);
    }, [onChange, notify, deliverySampleWarningMessage]);
    if (orderedItem.type === 'Offer' && orderedItem.isFoundingRoasterItem)
        return React.createElement("span", null, "-");
    if (orderedItem.alreadySampleOrdered) {
        return React.createElement("span", null, t('pages.roasterOrder.sampleOrdered'));
    }
    if (isSecondaryDirectSampleOrder && !orderedItem.offer.isAdditional)
        return React.createElement("span", null, "-");
    if (orderedItem.type === 'Offer' &&
        !(((_c = (_b = orderedItem.offer.offerList) === null || _b === void 0 ? void 0 : _b.roasterOfficeDetail) === null || _c === void 0 ? void 0 : _c.sampleOrderable) &&
            ((_d = orderedItem.offer.offerList) === null || _d === void 0 ? void 0 : _d.status) === 'active') &&
        role !== 'admin') {
        return React.createElement("span", null, "-");
    }
    if (orderedItem.remainingQuantity <= 0 ||
        orderedItem.sampleRemainingQuantity <= 0) {
        return React.createElement(SoldOutTag, null, t('pages.roasterOrder.outOfSamples'));
    }
    return (React.createElement("span", { onClick: handleClick },
        React.createElement(Checkbox, { checked: checked, onChange: handleChange, disabled: disabled })));
};
export default SampleOrderCheckbox;
